<template>
    <div id="app" style="position:relative;width: 100%;display: flex;justify-content: center;">
        <div style="width: 908px;height:910px;background: #FFFFFF;">
            <div class="head">完善采购信息</div>
            <div style="widht:100px;display: flex;justify-content: space-between;margin-top: 20px;">
                <div style="width: 65%">
                    <div class="typeface" style="width: 75px;height: 19px;font-size: 16px;margin-left: 54px;"><span style="color: red">*</span>采购名称</div>
                    <div style="width: 500px;height: 36px;border-radius: 5px;background: #FFFFFF;margin-left:54px;margin-top: 5px;">
                        <el-input v-model="names" placeholder=""></el-input>
                    </div>
                </div>
                <div style="width: 33%;">
                    <div style="display: flex">
                        <div style="font-family: 'FangSong';font-weight:bold;font-size: 16px;"><span style="color: red">*</span>分类：</div>
                        <el-radio v-model="radio" label="1" style="font-size: 17px;">服务</el-radio>
                        <el-radio v-model="radio" label="2" style="font-size: 17px;">产品</el-radio>
                    </div>
                    <div v-if="radio === '1'" style="width: 60px;height: 36px;border-radius: 5px;float: left;margin-top: 3px">
                        <el-cascader  v-model="types" :options="type_list"  placeholder="请选择服务"></el-cascader>
                    </div>
                    <div v-else-if="radio === '2'" style="width: 60px;height: 36px;border-radius: 5px;float: left;margin-top: 3px">
                        <el-cascader  v-model="types" :options="TypeList"  placeholder="请选择产品"></el-cascader>
                    </div>
                </div>
            </div>
            <div class="typeface" style="width: 105px;height: 19px;font-size: 16px;margin-top: 15px;margin-left: 54px;margin-bottom: 5px"><span style="color: red">*</span>采购详情描述</div>
                <div style="width: 800px;margin: 0 auto;">
                    <el-input  type="textarea" :rows="5" resize="none" placeholder="简单描述一下你的采购意愿及采购对象的详细内容，以及数量、规格、交付日期、服务条款和服务承诺等。如果需要图片则添 加图片信息等。" v-model="description" >
                    </el-input>
                </div>
            <!--   上传图片  -->
            <div class="input_box_btn op sc hand" @click="set_upload_img_open" style="position: relative;margin-left: 54px;">
                <div class="input_box_btn_icon" style="margin-top: 7px">
                    <svg t="1700457632553" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11668" width="25" height="25"><path d="M632 992H172.8c-70.4 0-128-57.6-128-128V352c0-176 144-320 320-320h267.2c70.4 0 128 57.6 128 128v704c0 70.4-57.6 128-128 128z" fill="#E1E1DF" p-id="11669"></path><path d="M852.8 992H326.4c-70.4 0-128-57.6-128-128V336c0-70.4 57.6-128 128-128h526.4c70.4 0 128 57.6 128 128v528c0 70.4-57.6 128-128 128z" fill="#4E8DF6" p-id="11670"></path><path d="M320 417.6a110.4 110.4 0 1 0 220.8 0 110.4 110.4 0 1 0-220.8 0Z" fill="#FFFFFF" p-id="11671"></path><path d="M875.2 606.4c-48-48-126.4-48-174.4 0L321.6 985.6l-6.4 6.4h536c70.4 0 128-57.6 128-128v-152l-104-105.6z" fill="#2166CC" p-id="11672"></path><path d="M731.2 992l-272-273.6c-48-48-126.4-48-174.4 0l-84.8 86.4V864c0 70.4 57.6 128 128 128h403.2z" fill="#629FF9" p-id="11673"></path></svg>
                </div>
                <div class="input_box_btn_name" >添加照片</div>
                <el-badge :value="imgs.length" style="position:absolute; z-index:10; left: 47px;top: 8px;" v-if="imgs.length > 0"></el-badge >
            </div>
            <!--    上传视频 -->
            <div class="input_box_btn op sc hand" @click="set_visibleVideos"  style="position: relative; margin-right: 8px">
                <div class="input_box_btn_icon" style="margin-top: 7px;margin-left: 10px">
                    <svg t="1700457844773" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="14809" width="25" height="25"><path d="M661.942857 73.142857H146.285714c-20.114286 0-36.571429 16.457143-36.571428 36.571429v804.571428c0 20.114286 16.457143 36.571429 36.571428 36.571429h731.428572c20.114286 0 36.571429-16.457143 36.571428-36.571429V325.485714L661.942857 73.142857z" fill="#8095FF" p-id="14810"></path><path d="M661.942857 288.914286c0 20.114286 16.457143 36.571429 36.571429 36.571428H914.285714L661.942857 73.142857v215.771429z" fill="#B6C6FF" p-id="14811"></path><path d="M632.685714 437.028571H301.714286c-20.114286 0-36.571429 18.285714-36.571429 42.057143v279.771429c0 23.771429 16.457143 42.057143 36.571429 42.057143h332.8c20.114286 0 36.571429-18.285714 36.571428-42.057143V479.085714c-1.828571-21.942857-18.285714-42.057143-38.4-42.057143z" fill="#FFFFFF" p-id="14812"></path><path d="M782.628571 513.828571c-9.142857-7.314286-20.114286-10.971429-31.085714-9.142857l-89.6 20.114286c-16.457143 3.657143-29.257143 21.942857-29.257143 42.057143v106.057143c0 20.114286 12.8 38.4 29.257143 42.057143l89.6 20.114285h7.314286c9.142857 0 16.457143-3.657143 23.771428-9.142857 9.142857-7.314286 12.8-20.114286 12.8-32.914286v-146.285714c0-12.8-3.657143-23.771429-12.8-32.914286z" fill="#FFFFFF" opacity=".8" p-id="14813"></path><path d="M488.228571 524.8h104.228572V566.857143h-104.228572z" fill="#8095FF" p-id="14814"></path></svg>
                </div>
                <div class="input_box_btn_name" >添加视频</div>
                <el-badge :value="videos.length" style="position:absolute; z-index:10; left:194px;top: 8px" v-if="videos.length > 0"></el-badge >
            </div>
            <!--   上传附件  -->
            <div class="input_box_btn op sc hand" @click="set_visibleFiles" style="position: relative; margin-right: 8px">
                <div class="input_box_btn_icon" style="margin-top: 7px;margin-left: 10px">
                    <svg t="1700458448013" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="21815" width="25" height="25"><path d="M881.371 362.057v570.514c0 25.6-18.285 43.886-43.885 43.886H186.514c-25.6 0-43.885-18.286-43.885-43.886V91.43c0-25.6 21.942-43.886 43.885-43.886h431.543l263.314 314.514z m-40.228 3.657L618.057 98.743l3.657 230.4c0 25.6 14.629 40.228 29.257 40.228l190.172-3.657z m-256-285.257H186.514c-7.314 0-10.971 3.657-10.971 10.972v844.8c0 7.314 3.657 10.971 10.971 10.971h650.972c7.314 0 10.971-3.657 10.971-10.971V402.286H650.971c-36.571 0-62.171-32.915-62.171-73.143l-3.657-248.686z" fill="#BEC3CC" p-id="21816"></path><path d="M881.371 501.029H142.63c-18.286 0-29.258 7.314-29.258 25.6v314.514c0 14.628 10.972 25.6 29.258 25.6h742.4c18.285 0 29.257-7.314 29.257-25.6V522.97c-3.657-14.628-10.972-21.942-32.915-21.942zM332.8 760.686h-14.629v-7.315c-3.657-7.314-3.657-14.628-3.657-18.285h14.629c10.971 0 14.628-7.315 14.628-18.286 0-14.629-7.314-32.914-18.285-51.2l18.285-69.486h-29.257v204.8h-25.6v-230.4h76.8v25.6l-18.285 65.829c14.628 18.286 18.285 36.571 18.285 58.514 0 25.6-10.971 36.572-32.914 40.229zM409.6 614.4v186.514H384V658.286c0 3.657-3.657 7.314-7.314 10.971s-7.315 10.972-7.315 10.972c0-3.658-3.657-10.972-3.657-18.286 0-3.657-3.657-10.972-3.657-10.972 18.286-29.257 32.914-58.514 40.229-91.428l25.6 3.657c-3.657 10.971-7.315 25.6-18.286 43.886v7.314zM522.971 640H501.03v120.686c0 25.6-10.972 36.571-32.915 36.571h-29.257c0-10.971-3.657-18.286-3.657-25.6h25.6c14.629 0 18.286-3.657 18.286-18.286V636.343h-51.2v-25.6h51.2v-51.2h25.6v51.2h21.943V640z m-106.057 25.6l21.943-7.314c7.314 18.285 18.286 36.571 25.6 51.2l-21.943 10.971c-7.314-18.286-18.285-36.571-25.6-54.857zM588.8 800.914h-25.6v-128c-7.314 10.972-14.629 25.6-25.6 36.572-3.657-14.629-3.657-25.6-7.314-36.572 18.285-29.257 36.571-65.828 47.543-109.714l25.6 7.314c-3.658 18.286-10.972 36.572-18.286 51.2v179.2z m190.171-80.457H716.8v76.8h-25.6v-76.8h-84.114v-25.6H691.2V640h-40.229c-3.657 14.629-10.971 29.257-14.628 40.229-3.657-3.658-10.972-3.658-18.286-7.315-3.657 0-3.657 0-3.657-3.657 10.971-25.6 21.943-54.857 29.257-95.086l25.6 3.658c-3.657 10.971-3.657 21.942-7.314 32.914h32.914v-54.857h25.6v54.857h54.857v25.6h-54.857v58.514h62.172v25.6z" fill="#0090FF" p-id="21817"></path></svg>
                </div>
                <div class="input_box_btn_name" style="">上传文件</div>
                <el-badge :value="files.length" style="position:absolute; z-index:10;left: 293px;top:8px" v-if="files.length > 0"></el-badge >
            </div>
            <!--    传图片  -->
            <el-dialog :close-on-click-modal="false" :show-close=false :append-to-body="true" :visible.sync="visibleImages" width="398px">
                <el-tabs v-model="src_tabs_name" type="border-card">
                    <el-tab-pane label="电脑上传" name="pc" >
                        <div>
                            <el-upload accept="image/*"  :on-change="onchange_imgs" style="width:330px" class="upload_url" action="" drag multiple :http-request="upload_img" :limit=80 :show-file-list="false" :on-exceed="fileListNum">
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
                            </el-upload>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="手机上传" name="mobile">
                        <div style="padding:10px;color:#a6a6a6;line-height:20px;">
                            <p>使用微信“扫一扫”打开小程序</p><P>在 百工宝小程序 中向“文件助手”发送文件</P>
                        </div>
                        <div style="text-align:center;">
                            <img src="https://baigongbao.oss-cn-beijing.aliyuncs.com/other/ewm/xcx.jpg" style="width:150px;height:150px;">
                        </div>

                    </el-tab-pane>
                </el-tabs>
                <div style="overflow: hidden; height:20px;line-height:20px; padding: 0 16px; margin-bottom: 10px">
                    <div style="float:left;">
                        图片:（{{imgs.length}}）<!-- /9 -->
                    </div>
                </div>
                <div style="overflow:hidden; display: flex; flex-wrap: wrap; padding: 0 16px" class="upload">
                    <div style="width: 160px; height: 120px; margin-right: 10px; margin-bottom: 10px; border-radius: 5px;background-size:100% 100%;" class="img" v-for="(item,index) in imgs" :key="index" :style="{backgroundImage:'url('+item.img_url}">
                        <div style="background:#ff7575;color:#FFF;text-align:center;width:20px;height:20px;line-height:20px;border-radius:10px;float:right; cursor:pointer;user-select: none;" @click="removeImg(index)">
                            <i class="el-icon-close"></i>
                        </div>
                    </div>
                </div>
                <div style="display: flex; justify-content: flex-end;">
                    <el-button style="width: 80px;border-radius: 5px; margin: 10px 20px" @click="cancelImg">取消</el-button>
                    <el-button style="width: 80px;border-radius: 5px; background-color: #031F88; color: #fff; margin: 10px 16px 10px 0" @click="visibleImages = false">确定</el-button>
                </div>
            </el-dialog>
            <!-- 传视频 -->
            <el-dialog :close-on-click-modal="false" :show-close=false :append-to-body="true" :visible.sync="visibleVideos" width="398px">
                <el-tabs v-model="active_name" type="border-card">
                    <el-tab-pane label="电脑上传" name="pc" >
                        <div>
                            <el-upload accept="video/*" :on-change="onchange_videos"  style="width:330px"  class="upload_url" action="" drag  :http-request="upload_video" :show-file-list="false">
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">将视频拖到此处，或<em>点击上传</em></div>
                            </el-upload>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="手机上传" name="mobile">
                        <div style="padding:10px;color:#a6a6a6;line-height:20px;">
                            <p>使用微信“扫一扫”打开小程序</p><P>在 百工宝小程序 中向“文件助手”发送文件</P>
                        </div>
                        <div style="text-align:center;">
                            <img src="https://baigongbao.oss-cn-beijing.aliyuncs.com/other/ewm/xcx.jpg" style="width:150px;height:150px;">
                        </div>
                    </el-tab-pane>
                </el-tabs>

                <div style="overflow: hidden; height:20px;line-height:20px; padding: 0 16px; margin-bottom: 10px">
                    <div style="float:left;color:#acacac;">
                        视频:（{{videos.length}}）
                    </div>
                </div>
                <div style="overflow:hidden;">
                    <div v-for="(item,index) in videos" :key="index" :style="{backgroundImage:'url('+item.img_url}" style="width:80px;height:80px;border-radius:3px; float:left; margin:5px; background-size:100% 100%;position:relative;">
                        <div style="width:100%;height:100%;background-color: rgba(0,0,0,.3);">
                            <img :src="ossUrl + 'img/video_play.png'" style="width:50%;height:50%;margin:25%;" />
                        </div>
                        <div style="background:#ff7575;color:#FFF;text-align:center;width:20px;height:20px;line-height:20px;border-radius:10px; cursor:pointer;user-select: none;position:absolute;right:0;top:0;" @click="removeVideo(index)">
                            <i class="el-icon-close"></i>
                        </div>
                    </div>
                </div>
                <div style="display: flex; justify-content: flex-end;">
                    <el-button style="width: 80px;border-radius: 5px; margin: 10px 20px" @click="cancelVideo">取消</el-button>
                    <el-button style="width: 80px;border-radius: 5px; background-color: #031F88; color: #fff; margin: 10px 16px 10px 0" @click="visibleVideos = false">确定</el-button>
                </div>
            </el-dialog>
            <!--      传文件   -->
            <el-dialog :close-on-click-modal="false" :show-close=false :append-to-body="true" :visible.sync="visibleFiles" width="398px">
                <el-tabs v-model="file_tag_name" type="border-card">
                    <el-tab-pane label="电脑上传" name="pc" >
                        <div class="file_style">
                            <div class="dragger-file">
                                <el-upload  accept=".pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx" style="width: 330px" class="upload_url"  action="" drag multiple :http-request="upload_file" :show-file-list="false" >
                                    <i class="el-icon-upload" ></i>
                                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                    <div class="format">仅限pdf、doc、docx、xls、xlsx等文件格式</div>
                                </el-upload>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="手机上传" name="mobile">
                        <div style="padding:10px;color:#a6a6a6;line-height:20px;">
                            <p>使用微信“扫一扫”打开小程序</p><P>在 百工宝小程序 中向“文件助手”发送文件</P>
                        </div>
                        <div style="text-align:center;">
                            <img src="https://baigongbao.oss-cn-beijing.aliyuncs.com/other/ewm/xcx.jpg" style="width:150px;height:150px;">
                        </div>
                    </el-tab-pane>
                </el-tabs>
                <div style="overflow: hidden; height:20px;line-height:20px; padding: 0 16px; margin-bottom: 10px">
                    <div style="float:left;color:#acacac;">
                        附件:（{{files.length}}）<!-- /9 -->
                    </div>
                </div>
                <div style="overflow:hidden;">
                    <div class="video" v-for="(item,index) in files" :key="index" style="width:80px;height:100px;border-radius:3px; float:left; margin:5px; background-size:100%;position:relative;" :title="item.file_name">
                        <div class="background" style="width:100%;height:calc(100% - 20px);background-color: rgba(0,0,0,.3);">
                            <!-- <div style="width:100%">{{item.file_name}}</div> -->
                            <img :src="ossUrl+'img/file.png'" style="width:100%;height:100%;" />
                        </div>
                        <div style="height:20px;width:70px;margin: 0 5px;line-height: 20px;text-align: center;word-break:keep-all;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{item.name}}</div>
                        <div style="background:#ff7575;color:#FFF;text-align:center;width:20px;height:20px;line-height:20px;border-radius:10px; cursor:pointer;user-select: none;position:absolute;right:0;top:0;" @click="removeFile(index)">
                            <i class="el-icon-close"></i>
                        </div>
                    </div>
                </div>
                <div style="display: flex; justify-content: flex-end;">
                    <el-button style="width: 80px;border-radius: 5px; margin: 10px 20px" @click="cancelFiles">取消</el-button>
                    <el-button style="width: 80px;border-radius: 5px; background-color: #031F88; color: #fff; margin: 10px 16px 10px 0" @click="visibleFiles = false">确定</el-button>
                </div>
            </el-dialog>

            <div style="width:100%;margin-top:40px;display: flex;clear: both">
                <div class="typeface" style="width: 128px;height: 19px;font-size: 16px;margin-top:23px;margin-left:54px"><span style="color: red">*</span>项目预算（元）:</div>
                <div style="width: 160px;margin-top:13px">
                    <el-input v-model="inputcol" placeholder="请输入预算(元)" @input="checkValuecode($event)" min="1" max="1000"></el-input>
                </div>
            </div>
            <div style="width:100%;display:flex;">
                <div class="typeface" style="width: 176px;height: 19px;font-size: 16px;margin-top:20px;margin-left: 54px">本信息要求的采购方式：</div>
                <div style="margin-top:20px;padding-left: 5px;">
                        <el-radio v-model="shoping" label="1">政府采购</el-radio>
                        <el-radio v-model="shoping" label="2">企业采购</el-radio>
                        <el-radio v-model="shoping" label="3">个人采购</el-radio>
                </div>
            </div>
            <div class="typeface" style="width: 105px;height: 19px;font-size: 16px;margin-top: 25px;margin-left: 54px;margin-bottom: 5px;"><span style="color: red">*</span>采购规格描述</div>
            <div style="width: 800px;margin: 0 auto">
                <el-input type="textarea" :rows="5" resize="none" placeholder="描述一下采购对象的型号、颜色、功率等。如果是采购服务，则描述一下该服务的指标性要求。" v-model="webshop"></el-input>
            </div>

            <div style="width: 100%;margin-top: 23px;display: flex;margin-left: 54px;">
                <div style="width: 47.5%;overflow: hidden">
                    <div class="typeface" style="width: 105px;height: 19px;font-size: 16px;margin-bottom: 5px;"><span style="color: red">*</span>报名截止日期</div>
                    <div style="width: 370px;">
                        <el-date-picker v-model="deadline" :picker-options="expireTimeOption"  format="yyyy-MM-dd HH:mm:ss"  type="datetime" @change="handleDate" placeholder="选择日期"></el-date-picker>
                    </div>
                </div>
                <div style="width: 50%">
                    <div class="typeface" style="width: 90px;height: 19px;font-size: 16px;margin-bottom: 5px;"><span style="color: red">*</span>项目所在地</div>
                    <div class="dragger-file">
                        <el-cascader v-model="city_id" ref="cascaderArr" :props="props" placeholder="选择城市"  @change="handleChange"></el-cascader>
                    </div>
                </div>
            </div>
            <div style="width: 100%;margin-top: 23px;display: flex;margin-left: 54px;">
                <div style="width: 20.5%;overflow: hidden;">
                    <div class="typeface" style="width: 96px;height: 19px;font-size: 16px;margin-bottom: 5px;"><span style="color: red">*</span>联系人</div>
                    <div style="width: 170px;">
                        <el-input v-model="user_name" type="text" placeholder="联系人"></el-input>
                    </div>
                </div>
                <div style="width: 35%;">
                    <div class="typeface" style="width: 80px;height: 19px;font-size: 16px;margin-bottom: 5px;"><span style="color: red">*</span>联系电话</div>
                    <div class="dragger-file" style="width: 300px;">
                        <el-input placeholder="请输入手机号"  autocomplete="new-password" :maxlength="11" v-model="reserve" type="tel"  pattern="[0-9]{11}" @input="UpNumber">
                            <template slot="prepend">中国 +86</template>
                        </el-input>
                    </div>
                </div>
                <div style="width: 35%">
                    <div class="typeface" style="width: 90px;height: 19px;font-size: 16px;margin-bottom: 5px;"><span style="color: red">*</span>手机验证码</div>
                    <div style="width: 300px;">
                        <el-input placeholder="输入6位短信验证码"  autocomplete="new-password" :maxlength="6" type="text" v-model="code">
                            <template slot="append">
                                <el-button
                                    type="primary"
                                    style="border-radius: 0 5px 5px 0;background: #2970FF;color: #FFFFFF;height: 40px;"
                                    :disabled="countdown>0"
                                    @click="sendVerificationCode"
                                >
                                    {{ countdown > 0 ? `${countdown}秒后重试` : '获取验证码' }}
                                </el-button>
                            </template>
                        </el-input>
                    </div>
                </div>
            </div>
            <div style="width: 100%;display: flex;justify-content: center;margin-top: 50px">
<!--                <div style="width: 80px;height: 19px;font-size: 16px;color: #333333;line-height: 0px; margin-top: 35px;cursor:pointer;margin-right: 10px" @click="add(0)">保存为草稿</div>-->
                <div style="height: 54px;border-radius: 5px 5px 5px 5px;opacity: 1;display: flex;justify-content: center; align-items: center;">
                    <el-button type="primary" @click="add(1)" style="border: 1px solid #409EFF;color: #FFFFFF">确认发布</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    components: {

    },
    data () {
        return {
            value: '',
            radio:'1',
            names: '',
            shopex:'1',
            showgit:'',
            textarea:'',
            description:'',
            inputcol:'',
            inputnane:'',
            inputagents:'',
            shoping:'1',
            webshop:'',
            options:[],
            optionsa:[],
            //图片
            imgs:[],
            removeImgs:[],
            //视频
            videos:[],
            removeVideos:[],
            //附件
            enclosure:[],
            fmList:[],
            end_time_str:'',
            city_id:"",
            user_name:"",
            reserve:"",
            expireTimeOption: {
                disabledDate(date) {
                    return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                }
            },
            deadline: "",
            type_list:[],
            TypeList:[],
            cityList:[],
            types:'',
            visibleImages: false,
            visibleVideos: false,
            visibleFiles:false,
            src_tabs_name: "pc",
            active_name: "pc",
            file_tag_name: 'pc',
            upload_qrcode:"https://baigongbao.oss-cn-beijing.aliyuncs.com/img/xcx_qrcode.jpg-80*80",
            files:[],
            props: {
                lazy: true,
                lazyLoad: (node, resolve) => {
                    var that = this;
                    const level = node.value;
                    if (level){
                        that.newApi.getCityList({ fid: level }).then(res => {
                            const nodes = res.data.map(item => ({
                                value: item.value,
                                label: item.label,
                                leaf: item.type >= 3
                            }))
                            resolve(nodes);
                        }).catch((err) => {
                            console.log(err)
                        })
                    }else {
                        that.newApi.getCityList({ fid: 1 }).then(res => {
                            resolve(res.data)
                        })
                    }
                }
            },
            code:'',
            countdown: 0,

        };
    },
    created:function(){
        this.getEquipmentTypeList();
        this.getTypeList()

    },
    mounted: function () {

    },
    props:{
        roomId:{
            type: Number,
            default() {
                return 0;
            }
        },
        type:{
            type: Number,
            default() {
                return 0;
            }
        }
    },
    watch: {
        type() {
            // 切换类型时清空已选择的内容
            this.types = [];
        },
    },
    methods:{
        UpNumber() {
            this.reserve = this.reserve.replace(/[^0-9]/g, "");
        },
        checkValuecode() {
            // this.inputcol = this.inputcol.replace(/[^0-9]/g, '');
            this.inputcol = this.inputcol.replace(/[^\d]/g, ''); // 仅保留数字
            // if (this.inputcol === '' || parseInt(this.inputcol) < 1) {
            //     this.inputcol = '1';
            // }
        },
        handleChange(value){
            console.log(value);
        },
        set_upload_img_open(){
            if(this.videos.length > 0 || this.files.length > 0){
                this.utils.err("图片、视频、文件只能上传一种");
                this.visibleVideos = false;
                return false;
            } else {
                this.visibleImages = true;
            }
            this.visibleImages = true;
        },
        //将上传图片的原路径赋值给临时路径
        onchange_imgs(file){
            this.tempImageUrl = URL.createObjectURL(file.raw);
        },
        // 上传图片
        upload_img(params) {
            this.img_length++ ;
            if (this.img_length>80) {
                this.$message.error('图片数量达到最大数量！');
                return false;
            }
            var that = this;
            var file = params.file;
            if (file.type.indexOf('image') > -1) {
                that.utils.upload(file,function(url){
	                if (!url){
		                return false;
	                }
                    let params = {};
                    params.name = url.name;
                    params.img_url = url.url;
                    params.hash = url.hash;
                    that.imgs.push(params);
                })
            }else{
                this.$message.error('只能上传图片！')
                return false
            }
        },
        fileListNum:function (files) {
            if (files.length>this.limit) {
                this.$message.error('图片数量不能超过80张!');
            }
        },
        // 取消图片上传
        cancelImg() {
            this.imgs = [];
            // this.$refs.popover.doClose();
            this.visibleImages = false;
        },
        // 取消视频上传
        cancelVideo() {
            this.videos = [];
            // this.$refs.popover2.doClose();
            this.visibleVideos = false;
        },
        // 取消文件上传
        cancelFiles() {
            this.files = [];
            this.visibleFiles = false;
        },
        removeImg:function(index){
            var that = this;
            that.utils.confirm("移除这个图片？",function(){
                that.removeImgs.push(that.imgs[index]);
                that.spaceSize = that.spaceSize - that.imgs[index].size;
                that.imgs.splice(index,1);
            })
        },
        // 视频
        set_visibleVideos(){
            if(this.imgs.length > 0 || this.files.length > 0){
                this.utils.err("图片、视频、文件只能上传一种");
                this.visibleVideos = false;
                return false;
            }
            this.visibleVideos = true;
            this.common_type = '1'
        },
        //获取本地视频封面
        onchange_videos(file){
            this.tempVideosUrl = URL.createObjectURL(file.raw);
        },

        removeVideo:function(index){
            var that = this;
            that.utils.confirm("移除这个视频？",function(){
                that.removeVideos.push(that.videos[index]);
                that.videos.splice(index,1);
                that.spaceSize = that.spaceSize - that.videos[index].size;
            })
        },
        // 上传视频
        upload_video(params) {
            var file = params.file;
            var that = this;
            let pa = {};

            if (file.type.indexOf('video') > -1) {
                that.utils.upload(file,function(url) {
	                if (!url){
		                return false;
	                }
                    pa.name = url.name;
                    pa.img_url = url.url + "?x-oss-process=video/snapshot,t_0,f_jpg";
                    pa.url = url.url;
                    pa.hash = url.hash;
                    that.videos.push(pa);
                })
            }else{
                this.$message.error('只能上传视频！')
                return false
            }
        },

        set_visibleFiles(){
            if(this.imgs.length > 0 || this.videos.length > 0){
                this.utils.err("图片、视频、文件只能上传一种");
                return false;
            }
            this.visibleFiles = true;
            this.common_type = '1'
        },
        //附件上传
        upload_file:function(params){
            var that = this;
            var file = params.file;
            that.openLoading('正在上传请稍后')
            that.utils.upload(file,function(url){
                if (!url){
                    return false;
                }
                var obj = {
                    name:url.name,
                    url:url.url,
                    hash:url.hash
                };
                that.files.push(obj);
                console.log(this.files);
            })
        },
        //移除附件
        removeFile:function(index){
            var that = this;
            that.utils.confirm("移除这个附件？",function() {
                that.fmList.splice(index, 1);
                that.enclosure.splice(index, 1);
            })
        },
        // 校验手机号
        sendVerificationCode() {
            const that = this;
            if (this.reserve === "" || this.reserve.length < 11){
                that.utils.err('请输入正确的手机号，长度不能少于11位')
                return;
            }
            if (this.countdown > 0) return;
            this.newApi.sendSms({
                "mobile":that.reserve,
                "smsType":2
            }).then((ret)=>{
                that.utils.sus(ret.data);
                this.startCountdown();
            }).catch((err)=>{
                that.utils.err(err);
            });
        },
        //倒计时
        startCountdown() {
            this.countdown = 60;
            const timer = setInterval(() => {
                this.countdown -= 1;
                if (this.countdown <= 0) {
                    clearInterval(timer);
                }
            }, 1000);
        },
        //上传按钮
        add:function (status){
            var that = this;
            var tracting = {};
            // 分类的 type
            tracting.type = that.types;
            if (tracting.type.length == 0){
                that.utils.err("请选择分类");
                return false
            }
            // 采购规格描述
            tracting.content = that.webshop;
            if (tracting.content.length == 0){
                that.utils.err("请填写规格描述");
                return false
            }
            //项目预算
            tracting.budget = that.inputcol;
            if (!/^[1-9]\d*$/.test(tracting.budget)) {
                that.utils.err("项目预算必须为大于0的整数");
                return false;
            }
            // 采购方式
            tracting.purchaseType = that.shoping;
            var params = {};
            // 0草稿1发布
            params.status = status;
            // room中发布
            params.roomId = this.roomId;
            // 采购详情描述
            params.content = that.description;
            if(params.content == ""){
                that.utils.err("请填写详情描述");
                return false;
            }
            // 1招标信息2采购信息3招募信息4商务信息5招商信息6需求信息
            params.type = that.type;
            // 标题
            params.title = that.names;
            if(params.title == ""){
                that.utils.err("请填写采购名称");
                return false;
            }
            params.other = JSON.stringify(tracting);
            params.images = that.imgs;
            params.videos = that.videos;
            params.files = that.files;
            params.images = JSON.stringify(that.imgs);
            params.videos = JSON.stringify(that.videos);
            params.files = JSON.stringify(params.files);


            var date = new Date(that.deadline);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            var d = date.getDate();
            d = d < 10 ? "0" + d : d;
            var h = date.getHours();
            h = h < 10 ? "0" + h : h;
            var minute = date.getMinutes();
            minute = minute < 10 ? "0" + minute : minute;
            var s = date.getSeconds();
            s = s < 10 ? "0" + s : s;

            params.endTime = y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + s;
            if (params.endTime.length == 0){
                that.utils.err("请填写截止日期");
                return false
            }
            params.projectAddress = that.city_id;
            if (params.projectAddress.length == 0){
                that.utils.err("请选择项目所在地");
                return false
            }
            params.contacts = that.user_name;
            if (params.contacts.length == 0){
                that.utils.err("请填写联系人");
                return false
            }
            params.phone = that.reserve;
            if (params.phone.length == 0){
                that.utils.err("请填写手机号");
                return false;
            } else {
                var re = /^1[3|5|6|7|8|9][0-9]\d{8}$/;
                if (!re.test(this.reserve)){
                    this.$message({
                        message: '手机号不正确',
                        type: 'warning',
                    });
                    return false;
                }
            }
            params.code = that.code;
            if (params.code === "" || params.code.length < 6){
                that.utils.err('请输入正确的验证码，长度不能少于6位');
                return false;
            }
            const currentTimestamp = new Date().getTime();
            const selectedTimestamp = new Date(this.deadline).getTime();
            const eightHoursInMilliseconds = 8 * 60 * 60 * 1000;

            if (selectedTimestamp - currentTimestamp > eightHoursInMilliseconds) {
                this.addBusinessInfo(params);
            } else {
                that.utils.err('报名截至时间不能小于8小时');
            }
        },
        addBusinessInfo(params){
            var that= this;
            that.openLoading("发布中...");
            that.newApi.addBusinessInfo(params).then((ret)=>{
                if(ret.isSuccess == 1){
                    that.utils.sus(ret.data);
                    that.$emit('close', that.type);
                    that.names = "";
                    that.types = "";
                    that.description = "";
                    that.imgs = [];
                    that.videos = [];
                    that.files = [];
                    that.inputcol = "";
                    that.shoping = '1';
                    that.webshop = "";
                    that.deadline = "";
                    that.city_id = "";
                    that.user_name = "";
                    that.reserve = "";
                    that.code = "";
                }
            }).catch((err)=>{
                console.log(err)
            })
        },
        handleDate(value) {
            this.deadline = value;
        },
        getEquipmentTypeList(){
            var that = this;
            that.newApi.getEquipmentTypeList({
                lv: 3,
            }).then((res)=>{
                that.TypeList = res.data;
            }).catch((err)=>{
                console.log(err)
            })
        },
        getTypeList(){
            var that = this;
            that.newApi.getTypeList({
                lv: 3,
            }).then((res)=>{
                that.type_list = res.data;
            }).catch((err)=>{
                console.log(err)
            })
        },
    }
}


</script>

<style scoped>
/deep/ .el-radio__label {
    font-size:18px;
}

/deep/ .el-radio__input .is-checked {
    font-size:19px;

}
.el-date-editor.el-input {
    width: 370px;
}
/deep/ .el-cascader .el-input {
    width: 200px;
}
.block {
    margin-left: 45px;
}
/deep/ .dragger-file  .el-cascader .el-input{
    width: 370px !important;
}
.input_box_btn_name{
    float:left;
    margin-top: 13px;
    cursor:pointer;
    font-family: "FangSong";
}
.input_box_btn_icon{
    float:left;
    font-size:20px;
    line-height:38px;
    margin-right:5px;
    margin-top: 10px;
}
/deep/ .el-radio__label {
    font-size: 16px;
}
/deep/ .upload_url .el-upload-dragger {
    width: 330px !important;
    height: 164px !important;
}
.head {
    width: 240px;
    height: 36px;
    color:#2970FF;
    font-size: 30px;
    line-height: 60px;
    margin: 0 auto;
    text-align: center;
}
.typeface {
    font-family: 'FangSong';
    font-weight:bold;
}
</style>

